import React from 'react';
import { T, fmtDate, toInputDate } from '../theme';
import { StatusBadge, TypeChips, AvatarStack } from './Bits';

// İnteraktif görev tablosu — inline status + due date, satıra tıkla detay aç.
export default function TaskTable({ title, titleRight, tasks = [], loading, onPatch, onOpen, showBrand = true }) {
  return (
    <div style={{ marginBottom: 22 }}>
      {title && (
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 8, gap: 12 }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
            <h3 style={{ color: T.text2, fontSize: 13, textTransform: 'uppercase', letterSpacing: 1, margin: 0 }}>{title}</h3>
            {titleRight}
          </div>
          <span style={{ fontSize: 12, color: T.muted }}>{tasks.length} görev</span>
        </div>
      )}
      <div style={{ background: T.card, border: `1px solid ${T.border}`, borderRadius: 10, overflow: 'hidden' }}>
        <div style={{ maxHeight: 25 * 44, overflowY: 'auto' }}>
          <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
            <thead>
              <tr style={{ position: 'sticky', top: 0, background: T.panel, zIndex: 2 }}>
                {showBrand && <Th>Marka</Th>}
                <Th>Görev</Th><Th>Task Type</Th><Th>Yaratılma</Th><Th>Due Date</Th>
                <Th>Status</Th><Th>SP</Th><Th>Assignee</Th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr><td colSpan={8} style={{ padding: 18, color: T.muted, textAlign: 'center' }}>Yükleniyor…</td></tr>
              ) : tasks.length === 0 ? (
                <tr><td colSpan={8} style={{ padding: 18, color: T.dim, textAlign: 'center' }}>Görev yok</td></tr>
              ) : tasks.map(t => (
                <tr key={t.id} style={{ borderTop: `1px solid ${T.border}` }}
                    onMouseEnter={e => e.currentTarget.style.background = T.panel}
                    onMouseLeave={e => e.currentTarget.style.background = 'transparent'}>
                  {showBrand && <Td onClick={() => onOpen(t)} style={{ cursor: 'pointer', color: T.text2 }}>{t.brand_name || t.company_name || '—'}</Td>}
                  <Td onClick={() => onOpen(t)} style={{ cursor: 'pointer', color: T.text, fontWeight: 600, maxWidth: 260 }}>{t.title}</Td>
                  <Td><TypeChips types={t.types} /></Td>
                  <Td style={{ color: T.muted, whiteSpace: 'nowrap' }}>{fmtDate(t.created_at)}</Td>
                  <Td onClick={e => e.stopPropagation()}>
                    <input type="date" value={toInputDate(t.due_date)}
                      onChange={e => onPatch(t.id, { due_date: e.target.value || null })}
                      style={{ background: T.panel, border: `1px solid ${T.border2}`, borderRadius: 6, color: T.text, padding: '4px 6px', fontSize: 12, colorScheme: 'dark' }} />
                  </Td>
                  <Td onClick={e => e.stopPropagation()}>
                    <StatusBadge value={t.status} onChange={v => onPatch(t.id, { status: v })} />
                  </Td>
                  <Td style={{ color: T.text2, textAlign: 'center' }}>{t.sprint_point ?? 0}</Td>
                  <Td><AvatarStack people={t.assignees} /></Td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
const Th = ({ children }) => <th style={{ textAlign: 'left', padding: '10px 12px', color: T.muted, fontSize: 11, fontWeight: 600, textTransform: 'uppercase', letterSpacing: .5 }}>{children}</th>;
const Td = ({ children, style, ...rest }) => <td style={{ padding: '8px 12px', ...style }} {...rest}>{children}</td>;
